export * from './types/api';
export * from './types/auth';
export * from './types/brand';
export * from './types/campaign';
export * from './types/campaign-member';
export * from './types/campaign-status';
export * from './types/creator';
export * from './types/instagram';
export * from './types/youtube';
export * from './types/deliverable';

export * from './types/waitlist';

// Firebase Web SDK singletons (Phase 1.3.1) — `auth`, `app`, `db`, `analytics`
export * from './auth';

// Shared axios apiClient + ApiError class + queryClient + humanizeApiError (Phase 1.3.2 + 1.3.3)
export * from './api';

export * from './telemetry';

// SSR-safe storage helper (Phase 1.3.3)
export * from './storage';

// Shared SSE hooks — useAiReviewSSE, useThreadsSSE, useRosterSSE (Phase 4)
export * from './sse';

// Notification context — v3 stub; both apps use this
export { NotificationProvider, useNotifications, type NotificationTab } from './notifications/NotificationContext';
